import { Injectable } from '@angular/core';
import { AdapterService } from './adapter.service';
import { environment } from '../../../environments/environment';
import { CartService } from './cart.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public count: number = 0;
  constructor(private readonly _adapterService: AdapterService,
    private readonly _cartService: CartService,
    private readonly _authService: AuthService,
    ) {
    this.getServerCount();
  }
  // getCount() {
  //   this.getServerCount();
  //   let list = this._adapterService.getLocalStorageValue(environment.storageKeys.cart)
  //   if (list) {
  //     //this.itemList = list;
  //     //this._adapterService.removeLocalStorageValue(`fotiou.cartlist`);
  //     //this.count = list.length;
  //     this.count = 0;
  //     list.forEach(item => {
  //       this.count++;
  //       item.childItems.forEach(child => {
  //         this.count++;
  //       });
  //     });
  //   } else {
  //     this.count = 0;
  //   }
  // }

  public getServerCount() {
    const loggedInUser = this._authService.getLoggedInUser();
    if (loggedInUser) {
    this._cartService.getCartItemCount(loggedInUser?.cartId)
      .subscribe((response) => {
        if (response?.value?.isSuccessful) { 
          this.count = response?.value?.data;
        }
      });
    } else {
      this.count = 0;
    }
  }
}
